import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=efaae20e&"
import script from "./Arrival.vue?vue&type=script&lang=js&"
export * from "./Arrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Arrival.vue"
export default component.exports